import React, { useEffect, useState } from 'react';
import NewReleaseGames from '@/pages/intelligence/pages/Potential/NewReleaseGames/components/NewReleaseGames';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import { history } from 'umi';
import {
  commonMobileDefaultFilterValue,
  handlePotentialNewReleaseFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import { getNewReleaseCompanyList } from '@/pages/intelligence/services/filter';
import { getOriginalShortLinkFilter, URL_FILTER_KEY, URL_CHART_TYPE } from '@intelligence/utils/urlPathCfg';
import { getTopNewReleaseCustomValidUrlParams, topchartNewReleaseConsoleValidCfg, hasShortLinkRatio } from '@intelligence/_config/urlPageValidCfg';

export default function NewReleaseConsoleGame(props: any) {
  const {
    entityType = 'console',
    pageLogInfo = dbiPageLogMes.potentialNewReleaseGamesConsoleGame,
  } = props;

  const hasUrlShortLink = hasShortLinkRatio.topMobileUpcoming;
  const [shortLinkLoading, setShortLinkLoading] = useState(hasUrlShortLink);
  const [urlCustomParams, setUrlCustomParams] = useState({});
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState({
    [URL_CHART_TYPE]: 'bar',
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const initPage = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    if (urlFilter) {
      // 有的筛选器的token时才用后面的参数，没有则不用
      const { params, validQuery } = getTopNewReleaseCustomValidUrlParams(history, topchartNewReleaseConsoleValidCfg);
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  useEffect(() => {
    buriedPointPage(pageLogInfo);
    // 进入页面时判断是否有tokenQuery等，有则进入
    initPage();
  }, []);

  const defaultFilterValue = {
    ...commonMobileDefaultFilterValue,
  };
  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: [
      filterKeyMap.MY_FILTER,
      filterKeyMap.ALL_Games,
      filterKeyMap.ALL_COMPANYS,
      // filterKeyMap.PHEAD_RANG,
    ],
    companyFilterParams: {
      entity_type: entityType,
      search_name: '',
      page: 1,
      file_page_size: 500,
      source_metric: {},
    },
    getCompaniesFetch: getNewReleaseCompanyList,
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions: [], // 国家筛选器options,
      defalutMarket: [], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: false,
      [filterKeyMap.ALL_Games]: {
        params: { entity_type: entityType, game_type: 'new_release' },
      }
    },
    showConfirmButton: true,
    haveFilterSaveBtn: true,
    handleFilterToApiParams: (params: any) => handlePotentialNewReleaseFilterParamsToApi(params, entityType),
    hasUrlShortLink,
  };

  return (
    <NewReleaseGames
      entityType={entityType}
      downloadFileName={'Potential_New Release Games_Console Games'}
      pageLogInfo={pageLogInfo}
      filterCfg={filterCfg}
      filterLoading={shortLinkLoading}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
    />
  );
}
